// some-inner-component.jsx
import { useSwiper } from "swiper/react";
import leftArrowIcon from "assets/Icon_Btn_Previous.png";
import rightArrowIcon from "assets/Icon_Btn_Next.png";
import React, { SetStateAction, useEffect } from "react";

type SwiperPrevButtonProps = {
  disabled: boolean;
  setDisableScrollLeft: React.Dispatch<SetStateAction<boolean>>;
  setDisableScrollRight: React.Dispatch<SetStateAction<boolean>>;
};

export const SwiperPrevButton: React.FC<SwiperPrevButtonProps> = ({
  disabled,
  setDisableScrollLeft,
  setDisableScrollRight,
}) => {
  const swiper = useSwiper();

  useEffect(() => {
    if (swiper.activeIndex === 0) {
      setDisableScrollLeft(true);
    }
  }, [swiper.activeIndex]);

  return (
    <button
      className={`SwiperPrev ${disabled ? "Disabled" : ""}`}
      disabled={disabled}
      onClick={() => {
        swiper.slidePrev();
        setDisableScrollRight(false);
      }}
    >
      <img src={leftArrowIcon} alt="previous" />
    </button>
  );
};

type SwiperNextButtonProps = {
  disabled: boolean;
  setDisableScrollLeft: React.Dispatch<SetStateAction<boolean>>;
  setDisableScrollRight: React.Dispatch<SetStateAction<boolean>>;
};

export const SwiperNextButton: React.FC<SwiperNextButtonProps> = ({
  disabled,
  setDisableScrollLeft,
  setDisableScrollRight,
}) => {
  const swiper = useSwiper();

  return (
    <button
      className={`SwiperNext ${disabled ? "Disabled" : ""}`}
      disabled={disabled}
      onClick={() => {
        swiper.slideNext();
        setDisableScrollLeft(false);
      }}
    >
      <img src={rightArrowIcon} alt="next" />
    </button>
  );
};

type SwiperButtonsProps = {
  disableScrollLeft: boolean;
  setDisableScrollLeft: React.Dispatch<SetStateAction<boolean>>;
  disableScrollRight: boolean;
  setDisableScrollRight: React.Dispatch<SetStateAction<boolean>>;
};
export const SwiperButtons: React.FC<SwiperButtonsProps> = ({
  disableScrollLeft,
  setDisableScrollLeft,
  disableScrollRight,
  setDisableScrollRight,
}) => {
  const swiper = useSwiper();

  return (
    <>
      <SwiperPrevButton
        disabled={disableScrollLeft}
        setDisableScrollRight={setDisableScrollRight}
        setDisableScrollLeft={setDisableScrollLeft}
      />
      <SwiperNextButton
        disabled={disableScrollRight}
        setDisableScrollLeft={setDisableScrollLeft}
        setDisableScrollRight={setDisableScrollRight}
      />
    </>
  );
};
